import { useState, useEffect } from "react";
import { useApi } from "../Api";

export const useFamilyCheck = (): boolean | null => {
  const api = useApi();
  const [hasFamily, setHasFamily] = useState<boolean | null>(null);

  useEffect(() => {
    const checkFamilyAssignment = async () => {
      try {
        const response = await api.get("/api/clientfamily/getfamilies");
        const families = response.data.families || [];
        setHasFamily(families.length > 0);
      } catch (err) {
        console.error("Failed to check family assignment", err);
        setHasFamily(false);
      }
    };

    checkFamilyAssignment();
  }, [api]);

  return hasFamily;
};
